import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';



@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  constructor(
    private titleService: Title,
    private router:Router
    ) { }

  ngOnInit(): void {
    this.titleService.setTitle('Aldawal');

    setTimeout(() => {
      this.router.navigate(['/Home'])
    }, 600); 
    if (!localStorage.getItem('up')) {
      localStorage.setItem('up', 'no reload')
      location.reload()
    } else {
      localStorage.removeItem('up')
    }
  }

}
